import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    defaultMessage: 'Return Details',
    description: 'Title for the return details section',
    id: 'ZpadmB',
  },
  sectionAriaLabel: {
    defaultMessage: 'Return Details expander section',
    description: 'Aria label for the expandable return details section',
    id: 'd2+D0s',
  },
  returnCounter: {
    description: 'Text showing the current return number and the total number of returns',
    defaultMessage: 'Return {count} (of {total})',
    id: 'PsL02g',
  },
  shipFromLabel: {
    defaultMessage: 'Ship From Address',
    description: 'Label for the ship from address field',
    id: 'aOStGT',
  },
  createdDateLabel: {
    defaultMessage: 'Created',
    description: 'Label for the created date field',
    id: '4FiCqe',
  },
  receivedDateLabel: {
    defaultMessage: 'Received',
    description: 'Label for the received date field',
    id: 'aUXl/v',
  },
  voidedDateLabel: {
    defaultMessage: 'Voided',
    description: 'Label for the voided date field',
    id: 'OJLrnV',
  },
  rmaNumberLabel: {
    defaultMessage: 'RMA Number',
    description: 'Label for the rma number field',
    id: 'W0u0aZ',
  },
});
